import { fromJS } from 'immutable';
import { SET_TOUR_ACTIVE } from './actions';

const initialState = fromJS({ active: false });

export default function introTourReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOUR_ACTIVE:
      return state.set('active', action.payload.active);

    default:
      return state;
  }
}
